/**
 * 遞迴過濾 Menu 樹，套用「啟用顯示」規則：
 *
 * - 有子層的節點（群組）：只要任一「可見」子層存在就顯示（不看自己的 Status）
 * - 葉節點（無子層）：Status !== 0 才顯示
 *
 * 被篩除的項目：
 *   1. 葉節點且 Status === 0（停用）
 *   2. 所有子層都不可見而變成「空群組」的節點（連鎖往上一併隱藏）
 *
 * 維持與既有第三層判斷一致：status 欄位不存在（undefined）時視為顯示。
 */
export function filterVisibleMenu(menuList = []) {
    if (!Array.isArray(menuList)) {
        return menuList;
    }

    return menuList.reduce((result, node) => {
        const hasSubMenu = Array.isArray(node.subMenu) && node.subMenu.length > 0;

        if (hasSubMenu) {
            const visibleSubMenu = filterVisibleMenu(node.subMenu);
            // 子層有任一可見 → 群組保留，並一併過濾子層
            if (visibleSubMenu.length > 0) {
                result.push({ ...node, subMenu: visibleSubMenu });
            }
        } else if (node.status !== 0) {
            // 葉節點：Status !== 0 才顯示
            result.push({ ...node });
        }

        return result;
    }, []);
}
